import React, { useContext, useRef } from 'react';
import { Controller } from 'react-hook-form';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { FaTimes } from 'react-icons/fa';

import FormData from './Form.context';
import Label from './Label.form';
import ErrorMsg from './ErrorMsg.form';

const Datepicker = props => {
	const {
		required = false,
		name,
	} = props;

	const { control } = useContext(FormData);
	const datepickerRef = useRef(null);

	return (
		<div className='form-group-old'>
			<Label {...props} />

			<Controller
				control={control}
				name={name}
				render={({ onChange, onBlur, value }) => (
					<ReactDatePicker
						onChange={onChange}
						onBlur={onBlur}
						selected={value}
						ref={datepickerRef}
					/>
				)}
				rules={{ required: { value: required, message: 'Required' } }}
			/>

			<ErrorMsg {...props} />

			<div
				className='datepicker__clear'
				onClick={() => datepickerRef.current.clear()}
			>
				<FaTimes />
			</div>
		</div>
	);
};

export default Datepicker;
